import DividerMui from '@mui/material/Divider';

import { styled } from '@mui/material/styles';

export const Divider = styled(DividerMui, { label: 'BulkPanelDivider' })(() => ({
  height: 24,
}));

Divider.defaultProps = {
  orientation: 'vertical',
};
